import ProductDimensions from '@/components/blocks/add_to_cart/ProductDimensions';
import {
  useProduct,
  useSelectedVariant
} from '@/components/product/product-context';

/**
 * The dimensions line a variant selector shows next to its label.
 *
 * Reads the selected variant, so callers must wrap it in a Suspense tag — the
 * boundary stays with the caller so each block keeps control of its own static
 * shell.
 */
export default function SelectedVariantDimensions({ showOffsetBlockSelector }) {
  const { settings } = useProduct();
  const { variant: selectedVariant } = useSelectedVariant();

  return (
    <ProductDimensions
      variantDetails={settings?.variant_details?.reference?.[0]?.variants}
      selectedVariant={selectedVariant}
      showOffsetBlockSelector={showOffsetBlockSelector}
    />
  );
}
